import { Head } from "@inertiajs/react"
import { CompanyLayout } from "~/components/company/CompanyLayout"
import { FounderSection } from "~/components/company/sections/FounderSection"
import { TechnologyStackSection } from "~/components/company/sections/TechnologyStackSection"

export default function About() {
  const goToContact = () => {
    window.location.href = "/#contact"
  }

  return (
    <CompanyLayout>
      <Head>
        <title>About Us | Optimal Dev Labs</title>
        <meta name="description" content="Learn about Optimal Dev Labs and our founder. We help founders ship production MVPs in 30 days using Rails and Next.js." />
        <meta name="keywords" content="about optimal dev labs, software development agency, rails development, next.js development, MVP development team" />
        <meta property="og:title" content="About Us | Optimal Dev Labs" />
        <meta property="og:description" content="Learn about Optimal Dev Labs and our founder. We help founders ship production MVPs in 30 days using Rails and Next.js." />
        <meta property="og:url" content="https://optimaldevlabs.com/about" />
        <meta name="twitter:title" content="About Us | Optimal Dev Labs" />
        <meta name="twitter:description" content="Learn about Optimal Dev Labs and our founder. We help founders ship production MVPs in 30 days using Rails and Next.js." />
        <link rel="canonical" href="https://optimaldevlabs.com/about" />
      </Head>
      <section className="w-full py-16 md:py-24 lg:py-32">
        <div className="container px-8 md:px-12 lg:px-16">
          <div className="flex flex-col items-center text-center space-y-6 max-w-3xl mx-auto">
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="Optimal Dev Labs" className="h-12 w-12 object-contain" />
              <span className="text-xl font-semibold text-gray-900">Optimal Dev Labs</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              About Us
            </h1>

            <p className="text-gray-600 text-lg md:text-xl leading-relaxed max-w-2xl">
              We're a focused development studio that helps founders and teams ship real products fast.
              No agency bloat, no endless meetings. Just experienced engineers who know how to deliver.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-24 bg-gray-50">
        <div className="container px-8 md:px-12 lg:px-16">
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h2>
                <p className="text-gray-600 leading-relaxed">
                  We believe great software shouldn't take months to build. Our mission is to help founders
                  validate their ideas faster by shipping production-ready MVPs in 30 days or less.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Approach</h2>
                <p className="text-gray-600 leading-relaxed">
                  We combine senior engineering expertise with AI-powered tools to deliver at 10x speed
                  without sacrificing quality. Fixed pricing, clear timelines, and direct communication.
                  No surprises, no excuses.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FounderSection onContactClick={goToContact} />
      <TechnologyStackSection />
    </CompanyLayout>
  )
}
